<section class="advanced-filters">
  <!-- dialog header -->
  <div class="advanced-filters__header">
    <button (click)="close()">
      <i class="iconsax advanced-filters__icon" icon-name="x"></i>
    </button>
  </div>

  <form [formGroup]="filtersForm" (ngSubmit)="onSubmitFilters()">
    <!-- filters -->
    <div class="advanced-filters__inputs">
      <!-- type stone input -->
      <pwj-select-dropdown
        hasSearch
        formControlName="category_type_id"
        class="filter-input"
        label="advanceFiltering.filtersInput.labels.productType"
        placeholder="advanceFiltering.filtersInput.placeholders.enterProductType"
        icon="grid-apps"
        iconPosition="left"
        variant="outlined"
        [options]="dropDownProductCategories"></pwj-select-dropdown>
      <!-- form stone input -->
      <pwj-select-dropdown
        hasSearch
        formControlName="category_id"
        class="filter-input"
        label="advanceFiltering.filtersInput.labels.stoneForm"
        placeholder="advanceFiltering.filtersInput.placeholders.enterStoneForm"
        icon="grid-apps"
        iconPosition="left"
        variant="outlined"
        [options]="dropDownProductTypes"></pwj-select-dropdown>
      <!-- Category Stone input -->
      <pwj-select-dropdown
        hasSearch
        formControlName="sub_category_ids"
        class="filter-input"
        label="advanceFiltering.filtersInput.labels.stoneCategory"
        placeholder="advanceFiltering.filtersInput.placeholders.enterStoneCategory"
        icon="grid-apps"
        iconPosition="left"
        variant="outlined"
        [options]="dropDownProductNames"
        [multiSelect]="true"></pwj-select-dropdown>
      <!-- Stone Grade input -->
      <pwj-select-dropdown
        class="filter-input"
        label="advanceFiltering.filtersInput.labels.stoneGrade"
        placeholder="advanceFiltering.filtersInput.placeholders.enterStoneGrade"
        icon="ranking-1"
        iconPosition="left"
        variant="outlined"
        [options]="stoneGrades"
        formControlName="metadata[stone_grade]"
        [multiSelect]="true"></pwj-select-dropdown>
      <!-- main Color -->
      <pwj-select-dropdown
        hasSearch
        formControlName="metadata[main_color]"
        class="filter-input"
        label="advanceFiltering.filtersInput.labels.mainColor"
        placeholder="advanceFiltering.filtersInput.placeholders.enterMainColor"
        icon="brush-4"
        iconPosition="left"
        variant="outlined"
        [options]="mainColors"
        [multiSelect]="true"></pwj-select-dropdown>
      <!-- Color Percentage -->
      <pwj-select-dropdown
        class="filter-input"
        label="advanceFiltering.filtersInput.labels.mainColorPercentage"
        placeholder="advanceFiltering.filtersInput.labels.mainColorPercentage"
        icon="brush-4"
        iconPosition="left"
        variant="outlined"
        [options]="colorPercentages"
        formControlName="metadata[color_percentage]"
        [multiSelect]="true"></pwj-select-dropdown>
      <!-- veins Color -->
      <pwj-select-dropdown
        hasSearch
        formControlName="metadata[veins]"
        class="filter-input"
        label="advanceFiltering.filtersInput.labels.veinsColor"
        placeholder="advanceFiltering.filtersInput.placeholders.enterVeinsColor"
        icon="brush-4"
        iconPosition="left"
        variant="outlined"
        [options]="mainColors"
        [multiSelect]="true"></pwj-select-dropdown>
      <!-- dots Color -->
      <pwj-select-dropdown
        hasSearch
        formControlName="metadata[dots]"
        class="filter-input"
        label="advanceFiltering.filtersInput.labels.dotsColor"
        placeholder="advanceFiltering.filtersInput.placeholders.enterDotsColor"
        icon="brush-4"
        iconPosition="left"
        variant="outlined"
        [options]="mainColors"
        [multiSelect]="true"></pwj-select-dropdown>
      <!-- halos Color -->
      <pwj-select-dropdown
        hasSearch
        formControlName="metadata[halos]"
        class="filter-input"
        label="advanceFiltering.filtersInput.labels.halosColor"
        placeholder="advanceFiltering.filtersInput.placeholders.enterHalosColor"
        icon="brush-4"
        iconPosition="left"
        variant="outlined"
        [options]="mainColors"
        [multiSelect]="true"></pwj-select-dropdown>
    </div>
    <!-- applied filters and submit btn -->

    <div class="advanced-filters__options">
      <div>
        @if (filtersChipsList && filtersChipsList.length > 0) {
          <div class="applied-filters">
            <h4 class="applied-filters__title">
              {{ 'advanceFiltering.filtersApplied' | translate }}
            </h4>
            <ul class="applied-filters__list no-scrollbar">
              @for (filter of filtersChipsList; track filter) {
                @if (filter.value.length > 0) {
                  <li class="applied-filters__chips">
                    <p class="filter-name">
                      @if (filter.multiValue) {
                        @for (value of filter.value; track value) {
                          <span>
                            {{ filter.translationKey + value | translate }}
                          </span>
                        }
                      } @else {
                        <span>
                          {{ filter.value.toString() | translate }}
                        </span>
                      }
                    </p>
                    <button
                      class="filter-remove-btn"
                      (click)="removeAppliedFilter(filter)">
                      <i class="info-name__icon iconsax" icon-name="x"></i>
                    </button>
                  </li>
                }
              }
            </ul>
          </div>
        }
      </div>

      <pwj-button
        class="submit-filters-btn"
        variant="primary"
        size="large"
        icon="chevron-right"
        [rotateIconInRtl]="true"
        [iconReversePosition]="true"
        type="submit"
        [disabled]="!filtersApplied || filtersApplied?.length === 0"
        >{{ 'advanceFiltering.applyFilters' | translate }}</pwj-button
      >
    </div>
  </form>
</section>
